import { getConfig } from "./config.js";
import { Elm } from "./Main.elm";

const app = Elm.Main.init({
  node: document.getElementById("elm-app"),
  flags: {
    backendUrl: getConfig()["backend-url"],
    serviceUrl: getConfig()["services-url"],
  },
});

// Set up ports
app.ports.requestSecureUuid.subscribe(() => {
  app.ports.receiveSecureUuid.send(crypto.randomUUID());
});

app.ports.refreshPage.subscribe(() => {
  window.location.reload();
});

// Handle redirect to login
app.ports.redirectToLogin.subscribe(function (loginUrl) {
  window.location.href = loginUrl;
});

// Handle getting current URL
app.ports.getCurrentUrl.subscribe(function () {
  app.ports.receiveCurrentUrl.send(window.location.href);
});
